import {Price} from 'components/shared';
import {FC} from 'react';
import {TranslationKeys} from 'translations';

import {OrderTotalListItem} from '..';

interface IProps {
  cartItemsPrice: number;
  t: (term: TranslationKeys) => string;
}

export const CostOfProducts: FC<IProps> = ({t, cartItemsPrice}) => {
  return (
    <OrderTotalListItem title={t('TOTAL_PRODUCTS')} boxProps={{borderBottom: '1px solid #E6E6E6'}}>
      <Price
        value={cartItemsPrice}
        priceProps={{
          fontWeight: '500',
        }}
      />
    </OrderTotalListItem>
  );
};
